import { Box, Container, Typography } from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import useBackButtonRedirect from "../hooks/useBackButton";
import SectionHeader from "../components/SectionHeader";
import { useNavigate } from "react-router-dom";
import { setAnalyticsData } from "../utils/firebaseLog";
import { UserDataContext } from "../context/UserDataContext";
export default function ReservationDateChangeComplete({ email }) {
  const { memberData } = useContext(UserDataContext);
  useEffect(() => {
    document.title = "予約日時変更完了 | じぶん専用IT相談室";
  }, []);
  useBackButtonRedirect();
  const navigate = useNavigate();
  return (
    <Box component={"section"} className="section bg-dots">
      <Container className="container">
        <SectionHeader
          currentPage={"予約日時を変更しました"}
          preHeading={"Successfull"}
        />
        <Typography className="text-center mobile-text-left">
          ご登録済みのメールアドレス宛にご予約内容をお送りいたしました。
        </Typography>
        <Typography className="text-center mobile-text-left">
          メールは{email}からお送りします。
        </Typography>
        <Typography className="text-center mobile-text-left">
          メールが届かない場合は、迷惑メールフォルダに分類されていないか
          ご確認お願いします。
        </Typography>
      </Container>
      <Box component={"section"} className="section text-center">
        <button className="classification-btn" onClick={() => navigate("/")}>
          ホームへ
        </button>
      </Box>
    </Box>
  );
}
